exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fileUploadContainer---2VGcG{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;background-color:#fff;padding:5px;font-size:16px;width:100%;max-width:446px}.fileUploadContainer---2VGcG>*{margin:0 5px}.fileUploadContainer---2VGcG .fileUploadHiddenInput---1xHDe{display:none}.fileUploadContainer---2VGcG .fileUploadInput---W2-Vj{pointer-events:none}.fileUploadContainer---2VGcG .fileUploadButton---1AV2l{height:27px}", ""]);

// exports
exports.locals = {
	"fileUploadContainer": "fileUploadContainer---2VGcG",
	"fileUploadHiddenInput": "fileUploadHiddenInput---1xHDe",
	"fileUploadInput": "fileUploadInput---W2-Vj",
	"fileUploadButton": "fileUploadButton---1AV2l"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/file-upload/index.scss
// module id = 756
// module chunks = 3